import { Avatar, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Notifications from "@mui/icons-material/NotificationsActiveOutlined";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import DraftsIcon from "@mui/icons-material/Drafts";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationList, getNotificationHistory, readUserNotification } from "../../store/actions/notificationActions";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        maxWidth: "36ch",
        backgroundColor: theme.palette.background.default,
    },
    inline: {
        display: "inline",
    },
}));

export default function NotificationList() {
    const classes = useStyles();
    let history = useHistory();
    const dispatch = useDispatch();
    const [notificationList, setNotificationList] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const { t } = useTranslation("translation");

    const { notifications } = useSelector(({ notification }) => notification);

    useEffect(() => {
        GetNotifications();
    }, []);

    useEffect(() => {
        if (notifications?.resultObject) {
            setNotificationList(notifications.resultObject);
            setPageLoaded(true);
        }
    }, [notifications]);

    const GetNotifications = () => {
        const userName = GetUsername();
        dispatch(getNotificationList(userName));
    };

    const GetUsername = () => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        return oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "");
    };

    const PushToNotificationPage = (url, id) => {
        history.push(url);
        ReadNotification(id);
    };

    const ReadNotification = (id) => {
        dispatch(getNotificationHistory(id));
    };

    const ReadNotificationAll = () => {
        const userName = GetUsername();
        dispatch(readUserNotification(userName));
    };

    return (
        <Grid id="nl_Grid" container justifyContent="center" style={{ marginTop: 10 }}>
            <List id="nl_List" className={classes.root}>
                {notificationList.length != 0 && (
                    <Button id="nl_button" onClick={ReadNotificationAll} variant="contained" color="primary" component="span">
                        <DraftsIcon /> &nbsp; {t("MarkAsAllRead")}
                    </Button>
                )}
                {pageLoaded === true ? (
                    notificationList.length != 0 ? (
                        notificationList.map((element, index) => {
                            return (
                                <React.Fragment>
                                    <ListItem id={`nl_ListItem_${index}`} key={element.id} button onClick={() => PushToNotificationPage(element.url, element.id)}>
                                        <ListItemAvatar id="nl_ListItemAvatar">
                                            <Avatar id={`nl_avatar_${index}`} alt={element.title} src={""}>
                                                <Notifications />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            id={`nl_ListItemText_${index}`}
                                            primary={element.title}
                                            secondary={
                                                <React.Fragment id={`nl_React_Fragment_${index}`}>
                                                    <Typography id={`nl_Typography_${index}`} component="span" variant="body2" className={classes.inline} color="textPrimary">
                                                        {element.content}
                                                    </Typography>
                                                </React.Fragment>
                                            }
                                        />
                                    </ListItem>
                                    <Divider />
                                </React.Fragment>
                            );
                        })
                    ) : (
                        <h3>{t("NoUnreadNotifications")}</h3>
                    )
                ) : null}
            </List>
            <LoadingBackdrop id="nl_loginBackDrop" />
        </Grid>
    );
}
